import * as React from 'react';
import { useRefContext } from './ref-context';
export function useRefTargetScroll() {
  var getTargets = useRefContext().getTargets;
  var scrollTo = React.useCallback(function (sectionName, offsetSections) {
    var _a = sectionName,
      sectionRef = getTargets([sectionName])[_a];
    if (!sectionRef || !sectionRef.current) {
      console.warn("useRefTargetScroll warning: " + sectionName + " is not a target ref");
      return;
    }
    var currentScroll = window.scrollY;
    var target = sectionRef.current.getBoundingClientRect().top;
    /**
     * Offset is calculated by for the sections you pass if offsetSection object.
     */
    var offset = 0;
    if (offsetSections && offsetSections.length > 0) {
      var offsetSectionNames = offsetSections.map(function (offsetSection) {
        return offsetSection && offsetSection.sectionName;
      });
      var offsetSectionRefs_1 = getTargets(offsetSectionNames);
      offset = offsetSections.reduce(function (offsetY, offsetSection) {
        var element = offsetSectionRefs_1[offsetSection.sectionName].current;
        return offsetY + (element && element.getBoundingClientRect().height || 0) * (offsetSection.offsetMultiplier || 1);
      }, 0);
    }
    window.scrollTo({
      behavior: 'smooth',
      top: currentScroll + target - offset
    });
  }, [getTargets]);
  return {
    scrollTo: scrollTo
  };
}
export default useRefContext;